import React from "react";
import AdminReservationCard from "./AdminReservationCard";

const AdminReservationCardList = ({queriedReservations}) => {
   console.log('queried reservations', queriedReservations)
   return (
      <div>
         { queriedReservations?.map((queriedReservation) => <AdminReservationCard 
         queriedReservation={queriedReservation}/>)}
      </div>   
   )
}

export default AdminReservationCardList;